import AllBuySidesGroupAccess from './AllBuySidesGroupAccess.component';

export default AllBuySidesGroupAccess;
